import React from 'react';
import { SketchField, Tools } from 'components/SketchField';

export default class QuizDraw extends React.Component {
    constructor(props) {
        super(props);
        this.state = { color: 'black', size: 3 };
        this._sketch = null;
    }

    getImageData() {
        return this._sketch.toDataURL();
    }

    clearSketch() {
        this._sketch.clear();
    }

    changeColor(color, size) {
        this.setState({ color: color, size: size });
    }

    renderColorButton(color, size) {
        return (
            <div
                key={color}
                style={{
                    width: 30,
                    height: 30,
                    marginRight: 5,
                    border: '1px solid #aaa',
                    backgroundColor: color,
                }}
                onClick={this.changeColor.bind(this, color, size)}
            />
        );
    }

    render() {
        const colors = ['black', 'blue', 'cyan', 'orange', 'yellow', 'red', 'pink', 'green', 'brown', 'gray'];
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <div
                    style={{ border: '3px dashed #aaa' }}
                    onClick={this.props.handleDrawAction}
                    onTouchStart={this.props.handleDrawAction}
                >
                    <SketchField
                        ref={(c) => (this._sketch = c)}
                        width='100%'
                        height='370px'
                        tool={Tools.Pencil}
                        lineColor={this.state.color}
                        lineWidth={this.state.size}
                        imageFormat='jpeg'
                        // backgroundColor="transparent"
                        backgroundColor='#ffffff'
                    />
                </div>
                <div
                    style={{
                        height: 40,
                        padding: 5,
                        cursor: 'pointer',
                        justifyContent: 'center',
                        display: 'flex',
                    }}
                >
                    {colors.map((color) => {
                        return this.renderColorButton(color, 3);
                    })}
                    <div
                        key={1}
                        style={{
                            width: 30,
                            height: 30,
                            marginRight: 2,
                            border: '1px solid #aaa',
                            backgroundColor: 'white',
                        }}
                        onClick={this.changeColor.bind(this, 'white', 15)}
                    >
                        <i
                            className='material-icons'
                            style={{
                                marginLeft: 3,
                                cursor: 'pointer',
                                fontFamily: 'Material Icons',
                                color: '#999',
                            }}
                        ></i>
                    </div>
                </div>
            </div>
        );
    }
}
